import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import { getUserDetails } from "../../Redux/UserDetailsSlice/UserDetailsSlice";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getLanguageModal } from "../../Redux/LanguageModal/languageModalSlice";
import Translate from "../Multilanguage/Translate";
import { setRTL } from "../../Redux/RTL/RTLSlice";
import { useTranslation } from "react-i18next";
import * as service from "./service";
import { useState } from "react";
import { authenticate, authenticate2, getUserSubscription, getLanguageList, updateUserLanguage } from "../../network/service";

export default function Util() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const { i18n } = useTranslation();
  const [hoveredMenuIndex, setHoveredMenuIndex] = useState(null);
  const location = useLocation();

  const handleMouseOver = (index, event) => {
    if (hoveredMenuIndex !== index) {
      setHoveredMenuIndex(index);
    }
  };

  const handleMouseLeave = () => {
    setHoveredMenuIndex(null);
  };

  const buildMenuPath = (parentPath, index) => (parentPath !== undefined ? `${parentPath}.${index}` : `${index}`);

  const renderMenuItems = (items, currentPath, activeMenuTracker = null, setActiveMenuTracker = null, parentPath, setBrowseHover, setBrowseMoreMediumDevice) => {
    return items?.map((item, index) => {
      const menuPath = buildMenuPath(parentPath, index);
      const fullCurrentPath = location.pathname + (location.hash || "");
      const itemPath = item?.seo_url ? `/${item?.seo_url}` : item?.link;
      const isActive =
        (activeMenuTracker && activeMenuTracker.menuPath === menuPath) ||
        (itemPath && (fullCurrentPath === itemPath || (location.pathname === itemPath && !location.hash)));
      const isWatchLive = i18n.t('watch_live');

      if (template === "TEMPLATE_12" && isWatchLive && location.pathname === "/live") {
        return null;
      }
      if (item?.type === "MENU") {
        return (
          <li
            key={index}
            className={`${hoveredMenuIndex === index ? "active" : ""} ${projectInfo?.projectConfig?.pubid === 50147 ? 'template-11-font' : ''} ${[50158, 50157].includes(projectInfo?.projectConfig?.pubid) ? "special-gradient" : ""}`}
            onMouseOver={(e) => handleMouseOver(index, e)}
            onMouseLeave={handleMouseLeave}
            style={projectInfo?.projectConfig?.pubid === 50134 ? { color: 'black' } : {}}
            role="menuitem"
            tabIndex={0}
            aria-label={item?.value}
            onFocus={e => setHoveredMenuIndex(index)}
          >
            <span style={isActive ? {
              borderBottom: "3px solid var(--button-color)", paddingBottom: "4px",
              color: [50158, 50157].includes(projectInfo?.projectConfig?.pubid)
                ? "white"
                : [50158, 50157].includes(projectInfo?.projectConfig?.pubid) ?
                  "black"
                  : undefined
            } : {}}>
              {template === "TEMPLATE_12" && isWatchLive ? <Translate textKey='watch_live' /> : item?.value}
              {template === "TEMPLATE_12" && isWatchLive && <span className="watchLiveArrow" style={{ fontSize: "12px", color: "white" }}>&#9654;</span>}
              {/* {template === "TEMPLATE_12" && isWatchLive && <svg style={{ verticalAlign: "middle", flexShrink: 0, marginInlineStart: "4px" }} width="18" height="18" viewBox="0 0 7 10" fill="currentColor"><path d="M2,1C1.2,1,0.5,1.6,0.5,2.5V7.5C0.5,8.4,1.2,9,2,9C2.5,9,2.9,8.8,3.5,8.4L9,5.6C9.7,5.2,9.7,4.8,9,4.4L3.5,1.6C2.9,1.2,2.5,1,2,1Z"/></svg>} */}
            </span>
            {hoveredMenuIndex === index && item?.items?.length > 0 && (
              <div className={((template === "TEMPLATE_9" || template === "TEMPLATE_12") ? "browseMoreContainerNew" : "browseMoreContainer")}
                onMouseOver={() => setHoveredMenuIndex(index)}
                onMouseLeave={handleMouseLeave}
              >
                <div className={`left ${item?.items?.some((subItem) => subItem?.type === "LINK") ? "block" : ""}`}>
                  {item?.items?.map((subItem, subIndex) => {
                    const subMenuPath = buildMenuPath(menuPath, subIndex);
                    const subIsActive = activeMenuTracker && activeMenuTracker.menuPath === subMenuPath;
                    if (subItem?.type === "MENU") {
                      return (
                        <div key={subIndex}>
                          <h1 className="categoryName">{subItem?.value}</h1>
                          <ul>
                            {renderMenuItems(subItem?.items, currentPath, activeMenuTracker, setActiveMenuTracker, subMenuPath, setBrowseHover, setBrowseMoreMediumDevice)}
                          </ul>
                        </div>
                      );
                    } else if (subItem?.type === "LINK") {
                      return null; // handled below
                    }
                    return null;
                  })}
                  {/* Render all LINK type items in a single <ul> for correct structure */}
                  {item?.items?.some(subItem => subItem?.type === "LINK") && (
                    <div>
                      <ul>
                        {item?.items?.map((subItem, subIndex) => {
                          const subMenuPath = buildMenuPath(menuPath, subIndex);
                          const subIsActive = activeMenuTracker && activeMenuTracker.menuPath === subMenuPath;
                          if (subItem?.type === "LINK") {
                            return (
                              <li
                                key={subIndex}
                                onClick={() => {
                                  if (setActiveMenuTracker) {
                                    const targetPath = subItem?.seo_url ? `/${subItem?.seo_url}` : subItem?.link;
                                    setActiveMenuTracker({
                                      path: targetPath,
                                      menuPath: subMenuPath
                                    });
                                  }
                                  if (subItem?.seo_url) {
                                    navigate(`/${subItem?.seo_url}`);
                                  } else if (subItem?.link) {
                                    window.open(subItem?.link, "_blank");
                                  }
                                }}
                                style={projectInfo?.projectConfig?.pubid === 50134 ? { color: 'black' } : {}}
                                className={`${projectInfo?.projectConfig?.pubid === 50147 ? 'template-11-font' : ''}`}
                              >
                                <span style={subIsActive ? {
                                  borderBottom: "3px solid var(--button-color)", paddingBottom: "4px",
                                  color: [50158, 50157].includes(projectInfo?.projectConfig?.pubid)
                                    ? "white"
                                    : [50158, 50157].includes(projectInfo?.projectConfig?.pubid) ?
                                      "black"
                                      : undefined
                                } : {}}>
                                  {subItem?.value}
                                  {/* {template === "TEMPLATE_12" && subItem?.value === i18n.t('watch_live') && <svg style={{ verticalAlign: "middle", flexShrink: 0, marginInlineStart: "4px" }} width="18" height="18" viewBox="0 0 7 10" fill="currentColor"><path d="M2,1C1.2,1,0.5,1.6,0.5,2.5V7.5C0.5,8.4,1.2,9,2,9C2.5,9,2.9,8.8,3.5,8.4L9,5.6C9.7,5.2,9.7,4.8,9,4.4L3.5,1.6C2.9,1.2,2.5,1,2,1Z"/></svg>} */}
                                  {template === "TEMPLATE_12" && subItem?.value === i18n.t('watch_live') && <span className="watchLiveArrow" style={{ fontSize: "12px", color: "white" }}>&#9654;</span>}
                                </span>
                              </li>
                            );
                          }
                          return null;
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )}
          </li>
        );
      } else if (item?.type === "LINK") {
        const handleLink = () => {
          if (setActiveMenuTracker) {
            const targetPath = item?.seo_url ? `/${item?.seo_url}` : item?.link;
            setActiveMenuTracker({
              path: targetPath,
              menuPath: menuPath
            });
          }
          if (item?.seo_url) {
            setBrowseHover(null);
            navigate(`/${item?.seo_url}`);
          } else if (item?.link) {
            setBrowseHover(null);
            window.open(item?.link, "_blank");
          }
          setBrowseHover && setBrowseHover(null);
          setBrowseMoreMediumDevice && setBrowseMoreMediumDevice(false);
        };
        const isVisuallyActive = isActive || hoveredMenuIndex === index;
        return (
          <li
            key={index}
            onClick={handleLink}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleLink();
              }
            }}
            onMouseOver={(e) => handleMouseOver(index, e)}
            onMouseLeave={handleMouseLeave}
            style={projectInfo?.projectConfig?.pubid === 50134 ? { color: 'black' } : {}}
            className={`${hoveredMenuIndex === index ? "active" : ""} ${projectInfo?.projectConfig?.pubid === 50147 ? 'template-11-font' : ''} ${[50158, 50157].includes(projectInfo?.projectConfig?.pubid) ? "special-gradient" : ""}`}
          >
            <span
              className={template === "TEMPLATE_12" && isWatchLive ? "watchLiveNavBtn" : ""}
              style={template === "TEMPLATE_12" ? (isWatchLive ? {
                fontWeight: "600", padding: "13px 35px", borderRadius: "32px", fontSize: "14px", width: "12rem",
                // justifyContent: "center", letterSpacing: "1px", display: "inline-flex", alignItems: "center", color: "white",
                justifyContent: "center", letterSpacing: "1px", display: "inline-flex", alignItems: "center", color: "white", gap: "8px",
              } : (isVisuallyActive ? {
                backgroundColor: "var(--button-color)", padding: "12px 28px", borderRadius: "20px",
                color: "white", display: "inline-flex", alignItems: "center",
                transition: "background-color 0.15s ease, padding 0.15s ease, border-radius 0.15s ease",
              } : {
                display: "inline-flex", alignItems: "center",
                transition: "background-color 0.15s ease, padding 0.15s ease, border-radius 0.15s ease",
              })) : (isActive ? (projectInfo?.projectConfig?.pubid === 50147 || template === "TEMPLATE_11") ? { backgroundColor: "var(--button-color)", padding: "5px" } : { borderBottom: "4px solid var(--button-color)", paddingBottom: "6px" } : {})}>
              {template === "TEMPLATE_12" && isWatchLive ? <Translate textKey='watch_live' /> : item?.value}
              {template === "TEMPLATE_12" && isWatchLive && <span className="watchLiveArrow" style={{ fontSize: "12px", color: "white" }}>&#9654;</span>}
              {/* {template === "TEMPLATE_12" && isWatchLive && <svg style={{ verticalAlign: "middle", flexShrink: 0, marginInlineStart: "4px" }} width="18" height="18" viewBox="0 0 7 10" fill="currentColor"><path d="M2,1C1.2,1,0.5,1.6,0.5,2.5V7.5C0.5,8.4,1.2,9,2,9C2.5,9,2.9,8.8,3.5,8.4L9,5.6C9.7,5.2,9.7,4.8,9,4.4L3.5,1.6C2.9,1.2,2.5,1,2,1Z"/></svg>} */}
            </span>
          </li>
        );
      }
      return null;
    });
  };
  const fetchMenuItems = async (appInfo, setMenuItems, setMainMenuItems) => {
    try {
      const menuResponse = await service.getMenuItems(appInfo);
      if (menuResponse?.status === 200) {
        setMenuItems(menuResponse?.data?.data);
        let items = menuResponse?.data?.menu || [];
        setMainMenuItems(items);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const fetchUserSubscriptionDetails = async (appInfo, setIsSubscribedUser) => {
    const userSubResponse = await getUserSubscription(appInfo);
    if (userSubResponse?.status === 200) {
      if (userSubResponse?.data?.length > 0 || userSubResponse?.data?.data?.length > 0) {
        setIsSubscribedUser(true);
      } else {
        setIsSubscribedUser(false);
      }
    }
  };

  const searchSubmit = (value, setInputValue, setSearchActive, previousLocation) => {
    if (value) {
      setInputValue("");
      setSearchActive(false);
      navigate(`/search?query=${value}`);
    } else {
      navigate(previousLocation?.pathname, { state: previousLocation?.state });
      setInputValue("");
    }
  };

  const searchSubmitBrowseMore = (value, setInputValue, setSearchActive, setBrowseMoreMediumDevice, previousLocation) => {
    setSearchActive(true);
    if (value) {
      setInputValue("");
      navigate(`/search?query=${value}`);
      setBrowseMoreMediumDevice(null);
    } else {
      navigate(previousLocation?.pathname, { state: previousLocation?.state });
      setInputValue("");
    }
  };

  const logoutHandler = (appInfo) => {
    localStorage.removeItem("userId");
    localStorage.removeItem("selectedSubId");
    localStorage.removeItem("deviceType");
    localStorage.removeItem("selectedAmount");
    localStorage.removeItem("vanityUrl");
    localStorage.removeItem("token");
    localStorage.removeItem("sessionId");
    // localStorage.removeItem("selectedLanguageCode");
    // localStorage.removeItem("selectedLanguageName");
    // localStorage.removeItem("selectedLanguageId");
    tokenAuthenticate(appInfo);
    window?.FB && window.FB.logout(function (response) { });
  };

  const tokenAuthenticate = async (appInfo) => {
    const response = await authenticate2(appInfo);
    if (response?.status === 200) {
      dispatch(
        getLanguageModal({
          languageModal: {
            selectedLanguageCode: response?.data?.user_language?.short_code,
          }
        }))
      dispatch(
        getAccessToken({
          accessToken: response?.data?.token,
        })
      );
      dispatch(
        getUserDetails({
          userDetails: response?.data,
        })
      );
      navigate("/home");
      setTimeout(() => {
        dispatch(
          getUser({
            user: null,
          })
        );
      }, 300);
    }
  };

  const languageHandler = (selectedLanguage, selectedLanguageCode) => {
    let data = {
      isOpen: true,
      selectedLanguage: selectedLanguage ? selectedLanguage : null,
      selectedLanguageCode: selectedLanguageCode ? selectedLanguageCode : localStorage?.selectedLanguageCode
    };
    dispatch(
      getLanguageModal({
        languageModal: data,
      })
    );
  };

  const menuNavigateHandler = (data, setBrowseHover, setBrowseMoreMediumDevice) => {
    setBrowseHover(null);
    setBrowseMoreMediumDevice(false);
    if (data?.type === "LINK") {
      if (data?.seo_url) {
        setBrowseHover(null);
        navigate(data?.seo_url);
      } else if (data?.link) {
        window.open(data?.link, "_self");
      }
    } else {
      setBrowseHover(null);
      navigate(`/category/${data?.key}`, { state: { careers: data?.key } });
    }
  };

  const hexToRgb = (hex) => {
    hex = hex.replace("#", "");
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    return `${r}, ${g}, ${b}`;
  };

  const handleLanguageClick = (e, setIsLanguageOpen, browseMoreContainerRef) => {
    e.stopPropagation();
    setIsLanguageOpen(prev => !prev);

    setTimeout(() => {
      if (browseMoreContainerRef.current) {
        browseMoreContainerRef.current.scrollTo({
          top: browseMoreContainerRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const fetchLanguageOptions = async (appInfo, setLanguageOptions, setSelectedLanguage, i18n, projectInfo, userDetails, user) => {
    try {
      const response = await getLanguageList(appInfo);
      const data = response?.data?.data;
      setLanguageOptions(data);

      let selectedLang;
      if (user && userDetails?.language_id) {
        selectedLang = data.find(
          option => option?.language_id === parseInt(userDetails?.language_id) || option?.short_code === userDetails?.short_code
        );
      }

      if (!selectedLang) {
        const savedLanguageId = localStorage.getItem("selectedLanguageId");
        const savedLanguageCode = localStorage.getItem("selectedLanguageCode");

        selectedLang = data.find(
          option =>
            option?.language_id === parseInt(savedLanguageId) ||
            option?.short_code === savedLanguageCode
        );
      }

      if (!selectedLang) {
        selectedLang = data.find(option => option?.short_code === 'en') || data[0];
      }

      setSelectedLanguage(selectedLang);

      if (selectedLang?.short_code) {
        i18n.changeLanguage(selectedLang.short_code);
        if (!i18n.hasResourceBundle(selectedLang.short_code, 'translation')) {
          i18n.addResourceBundle(
            selectedLang.short_code,
            'translation',
            projectInfo?.projectConfig?.config?.LANGUAGE_KEYWORDS,
            true,
            true
          );
        }
      }
    } catch (error) {
      console.error("Failed to fetch language options:", error);
    }
  };

  const handleLanguageChange = async (language, setSelectedLanguage, setIsLanguageOpen, appInfo, projectInfo, getLanguageModal, getUserDetails, userDetails, languageOptions) => {
    try {
      setSelectedLanguage(language);
      setIsLanguageOpen(false);

      const response = await updateUserLanguage(appInfo, language.language_id);

      if (response?.status === 200) {
        const authResponse = await authenticate(appInfo);

        localStorage.setItem('selectedLanguageCode', language.short_code);
        localStorage.setItem('selectedLanguageId', language.language_id.toString());
        localStorage.setItem('selectedLanguageName', language.language_name);

        const hasResources = i18n.hasResourceBundle(language.short_code, 'translation');

        if (!hasResources) {
          try {
            i18n.addResourceBundle(
              language.short_code,
              'translation',
              projectInfo?.projectConfig?.config?.LANGUAGE_KEYWORDS,
              true,
              false
            );
          } catch (error) {
            console.warn('Resource bundle already exists:', error);
          }
        }

        await i18n.changeLanguage(language.short_code);

        dispatch(
          getLanguageModal({
            languageModal: {
              selectedLanguageCode: language.short_code
            }
          })
        );

        dispatch(
          getUserDetails({
            userDetails: {
              ...userDetails,
              language_id: language.language_id,
              short_code: language.short_code
            }
          })
        );

        dispatch(setRTL(language));

        toast.success(response?.data?.message, {
          position: "top-center"
        });
      }
    } catch (error) {
      console.error("Failed to update language:", error);
      toast.error(<Translate textKey={'failed_to_update_language'} />, {
        position: "top-center"
      });

      const savedLang = languageOptions.find(
        opt => opt.language_id === parseInt(localStorage.getItem("selectedLanguageId"))
      );
      if (savedLang) {
        setSelectedLanguage(savedLang);
        i18n.changeLanguage(savedLang.short_code).catch(console.error);
      }
    }
    window.location.reload();
  };

  return {
    fetchMenuItems,
    fetchUserSubscriptionDetails,
    searchSubmit,
    searchSubmitBrowseMore,
    logoutHandler,
    tokenAuthenticate,
    languageHandler,
    menuNavigateHandler,
    hexToRgb,
    handleLanguageClick,
    fetchLanguageOptions,
    handleLanguageChange,
    renderMenuItems,
  };
}
